<script setup lang="ts">

import type { EcommerceItem } from '@/types/shared/player-config'
import { twMerge } from 'tailwind-merge'
import { computed } from 'vue'

const props = defineProps<{
	limitedPack: EcommerceItem
	isLarge?: boolean
}>()

const cardStyle = computed(() => ({
  backgroundImage: `
    url("${props.limitedPack.buttonImageUrl ?? props.limitedPack.imageUrl}"),
    linear-gradient(90deg,
      rgba(255,255,255,.4) 0%,
      rgba(255,255,255,1) 50%,
      rgba(255,255,255,.4) 100%
    )
  `,
}))
</script>

<template>
  <div
    v-if="limitedPack"
    :class="twMerge('relative flex border-transparent [background-repeat:no-repeat,no-repeat] [background-clip:padding-box,border-box] [background-origin:padding-box,border-box]', isLarge ? 'border-[3px] size-[88px] min-h-[88px] p-[3.5px] rounded-[22px] pulse-shadow-large' : 'size-[52px] p-0.5 rounded-[13px] pulse-shadow-small', !props.limitedPack.buttonImageUrl ? '[background-position:bottom_left,center] [background-size:130%,100%_100%] ' : '[background-size:100%,100%_100%] ')"
    :style="cardStyle"
  >
    <slot />
  </div>
</template>
<style scoped>
.bg-dark-gold {
	background: linear-gradient(105deg, #FFCB00 10.46%, #B57800 61.24%, #B77C07 70.47%, #BF881B 82.01%, #CB9D3C 95.86%, #DCB96A 112.01%, #F1DDA5 130.48%, #FFF4C9 139.71%, #EACE88 153.55%, #D8AD4E 167.4%, #CB9423 178.94%, #C38509 188.17%, #C08000 192.79%, #C58500 197.41%, #EAB200 227.41%, #F9C300 241.26%);
}

@keyframes pulse-shadow-small {
	0% {
		filter: drop-shadow(0px 0px 0px rgba(253, 240, 104, 0));
	}
	50% {
		filter: drop-shadow(0px 0px 10px rgba(253, 240, 104, 1));
	}
	100% {
		filter: drop-shadow(0px 0px 6px rgba(253, 240, 104, 0));
	}
}

.pulse-shadow-small {
	animation: pulse-shadow-small 1.5s infinite linear;
	will-change: filter;
}

@keyframes pulse-shadow-large {
	0% {
		filter: drop-shadow(0px 0px 0px rgba(253, 240, 104, 0));
	}
	50% {
		filter: drop-shadow(0px 0px 22px rgba(253, 240, 104, 1));
	}
	100% {
		filter: drop-shadow(0px 0px 6px rgba(253, 240, 104, 0));
	}
}

.pulse-shadow-large {
	animation: pulse-shadow-large 1.5s infinite linear;
	will-change: filter;
}
</style>
